import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, formatDate } from "../../utils/const";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { allLocation } from "../../redux/common/locationSlice";
import { Typography } from "@mui/material";
import { border, Box } from "@mui/system";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";

function ApplycandidateHistoryDrawer({
  handleClose,
  show,
  historyOneData,
  totalCount,
}) {
  const locations = useSelector((state) => state.location) || [];
  const massmailStatus = useSelector((state) => state.massmail.status);
  const workautho = useSelector((state) => state.workautho);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  //   const allCandidates = candidateData?.results?.flatMap(
  //     (recruiter) => recruiter?.candidates
  //   );

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "470px",
        padding: "0 0 0 10px",
        border: "1px solid #f2f2f2",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography>
            <b>History of Delivery Mailing</b>
          </Typography>
          <Typography>Mailing ID :DRP00127 </Typography>
          <Typography>
            {totalCount} Candidate
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <RxCross2
            style={{
              fontSize: "22px",
              cursor: "pointer",
              marginBottom: "10px",
              color: customTextColor,
            }}
            onClick={handleClose}
          />
          <Typography>
            {/* <b>20th jan 2025, 10:50 PM</b> */}
          </Typography>
        </Box>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          {historyOneData?.results?.length > 0 &&
            historyOneData?.results.map((candidate) => (
              <div
                key={candidate?.candidate_details?.data?.[0].id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  border: "1px solid #f2f2f2",
                  borderRadius: "3px",
                  marginBottom: "8px",
                }}
              >
                <div>
                  <p style={{ marginBottom: "0" }}>
                    <b> {candidate?.candidate_details?.data?.[0]?.fullName}</b>{" "}
                    - {candidate?.candidate_details?.data?.[0]?.currentJobTitle}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "gray",
                      marginBottom: "0",
                    }}
                  >
                    {getPreferLocationNames(
                      candidate?.candidate_details?.data?.[0]?.preferLocation
                    )}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "gray",
                      marginBottom: "0",
                    }}
                  >
                    {getWorkAuthorization(
                      candidate?.candidate_details?.data?.[0]?.workAuthorization
                    )}
                  </p>
                </div>
                <Typography sx={{ alignSelf: "baseline" }}>
                  {formatDate(
                    candidate?.candidate_details?.data?.[0]?.createdAt
                  )}
                </Typography>
              </div>
            ))}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default ApplycandidateHistoryDrawer;
